import React, { useContext } from "react";
import { useSessionId, ThemeContext, useAuthProvider, Result, useDataProvider, Api, callApi, DataContext, Loader, Record, FormBuilder,
    DynamicObjectType
 } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import FormWizard from "@cloudpremise/portal_core/src/themes/mui/components/FormWizard";
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import Link from "@mui/material/Link";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
import { ReactSortable } from "react-sortablejs";
import Snackbar from '@mui/material/Snackbar';

import "../../styles/formbuilder.scss";

const SetupFormWizard = ({objectType}) => {
    const dataProvider = useContext(DataContext);
    let defaultState = {
        expandedPanels: {
            panelfields: false,
            layout: false
        },
        urlEditMode: false,
        statusCode: null,
        fields: [
            {
                "type": "ID",
                "name": "Id",
                "length": "18",
                "label": "Case ID",
                "custom": "false"
            },
            {
                "type": "STRING",
                "name": "CaseNumber",
                "length": "30",
                "label": "Case Number",
                "custom": "false"
            },
            {
                "type": "STRING",
                "name": "SuppliedName",
                "length": "80",
                "label": "Name",
                "custom": "false"
            },
            {
                "type": "EMAIL",
                "name": "SuppliedEmail",
                "length": "80",
                "label": "Email Address",
                "custom": "false"
            },
            {
                "type": "STRING",
                "name": "SuppliedPhone",
                "length": "40",
                "label": "Phone",
                "custom": "false"
            },
            {
                "type": "STRING",
                "name": "SuppliedCompany",
                "length": "80",
                "label": "Company",
                "custom": "false"
            },
            {
                "type": "PICKLIST",
                "name": "Type",
                "length": "255",
                "label": "Case Type",
                "custom": "false"
            },
            {
                "type": "PICKLIST",
                "name": "Status",
                "length": "255",
                "label": "Status",
                "custom": "false"
            },
            {
                "type": "PICKLIST",
                "name": "Reason",
                "length": "255",
                "label": "Case Reason",
                "custom": "false"
            },
            {
                "type": "PICKLIST",
                "name": "Origin",
                "length": "255",
                "label": "Case Origin",
                "custom": "false"
            },
            {
                "type": "BOOLEAN",
                "name": "IsVisibleInSelfService",
                "length": "0",
                "label": "Visible in Self-Service Portal",
                "custom": "false"
            },
            {
                "type": "STRING",
                "name": "Subject",
                "length": "255",
                "label": "Subject",
                "custom": "false"
            },
            {
                "type": "PICKLIST",
                "name": "Priority",
                "length": "255",
                "label": "Priority",
                "custom": "false"
            },
            {
                "type": "TEXTAREA",
                "name": "Description",
                "length": "32000",
                "label": "Description",
                "custom": "false"
            },
            {
                "type": "BOOLEAN",
                "name": "IsClosed",
                "length": "0",
                "label": "Closed",
                "custom": "false"
            },
            {
                "type": "DATETIME",
                "name": "ClosedDate",
                "length": "0",
                "label": "Closed Date",
                "custom": "false"
            },
            {
                "type": "BOOLEAN",
                "name": "IsEscalated",
                "length": "0",
                "label": "Escalated",
                "custom": "false"
            },
            {
                "type": "BOOLEAN",
                "name": "HasCommentsUnreadByOwner",
                "length": "0",
                "label": "New Self-Service Comment",
                "custom": "false"
            },
            {
                "type": "BOOLEAN",
                "name": "HasSelfServiceComments",
                "length": "0",
                "label": "Self-Service Commented",
                "custom": "false"
            },
            {
                "type": "REFERENCE",
                "name": "OwnerId",
                "length": "18",
                "label": "Owner ID",
                "custom": "false"
            },
            {
                "type": "BOOLEAN",
                "name": "IsClosedOnCreate",
                "length": "0",
                "label": "Closed When Created",
                "custom": "false"
            },
            {
                "type": "BOOLEAN",
                "name": "IsSelfServiceClosed",
                "length": "0",
                "label": "Closed by Self-Service User",
                "custom": "false"
            },
            {
                "type": "DATETIME",
                "name": "SlaStartDate",
                "length": "0",
                "label": "Entitlement Process Start Time",
                "custom": "false"
            },
            {
                "type": "DATETIME",
                "name": "SlaExitDate",
                "length": "0",
                "label": "Entitlement Process End Time",
                "custom": "false"
            },
            {
                "type": "BOOLEAN",
                "name": "IsStopped",
                "length": "0",
                "label": "Stopped",
                "custom": "false"
            },
            {
                "type": "DATETIME",
                "name": "StopStartDate",
                "length": "0",
                "label": "Stopped Since",
                "custom": "false"
            },
            {
                "type": "DATETIME",
                "name": "CreatedDate",
                "length": "0",
                "label": "Created Date",
                "custom": "false"
            },
            {
                "type": "REFERENCE",
                "name": "CreatedById",
                "length": "18",
                "label": "Created By ID",
                "custom": "false"
            },
            {
                "type": "DATETIME",
                "name": "LastModifiedDate",
                "length": "0",
                "label": "Last Modified Date",
                "custom": "false"
            },
            {
                "type": "REFERENCE",
                "name": "LastModifiedById",
                "length": "18",
                "label": "Last Modified By ID",
                "custom": "false"
            },
            {
                "type": "DATETIME",
                "name": "SystemModstamp",
                "length": "0",
                "label": "System Modstamp",
                "custom": "false"
            },
            {
                "type": "PHONE",
                "name": "ContactPhone",
                "length": "40",
                "label": "Contact Phone",
                "custom": "false"
            },
            {
                "type": "PHONE",
                "name": "ContactMobile",
                "length": "40",
                "label": "Contact Mobile",
                "custom": "false"
            },
            {
                "type": "EMAIL",
                "name": "ContactEmail",
                "length": "80",
                "label": "Contact Email",
                "custom": "false"
            },
            {
                "type": "PHONE",
                "name": "ContactFax",
                "length": "40",
                "label": "Contact Fax",
                "custom": "false"
            },
            {
                "type": "TEXTAREA",
                "name": "Comments",
                "length": "4000",
                "label": "Internal Comments",
                "custom": "false"
            },
            {
                "type": "DATETIME",
                "name": "LastViewedDate",
                "length": "0",
                "label": "Last Viewed Date",
                "custom": "false"
            },
            {
                "type": "DATETIME",
                "name": "LastReferencedDate",
                "length": "0",
                "label": "Last Referenced Date",
                "custom": "false"
            },
            {
                "type": "STRING",
                "name": "MilestoneStatus",
                "length": "30",
                "label": "Milestone Status",
                "custom": "false"
            }
        ],
        field: null,
        formType: "form",
        form: [
            {
                heading: null,
                fields: [],
                conditionalStep: false,
                conditionalStepValue: null,
                conditionalField: null,
                conditionalFieldValue: [],
                conditionalSubField: null,
                conditionalSubFieldValue: null
            }
        ],
        openMenu: false,
        currentFormTab: 0,
        currentForm: null,
        dynamicObjectType: null,
        loading: false,
        layouts: [
            {
                type: "layout",
                fieldType: "PANEL",
                label: "Panel",
                apiName: "",
                isRequired: false,
                value: ''
            },
            {
                type: "layout",
                fieldType: "TEXT",
                label: "Static Text",
                apiName: "",
                isRequired: false,
                value: ''
            },
            {
                type: "layout",
                fieldType: "HTML",
                label: "Rich Text",
                apiName: "",
                isRequired: false,
                value: ''
            },
            {
                type: "layout",
                fieldType: "FILE",
                label: "File",
                apiName: "",
                isRequired: false,
                value: ''
            },
            {
                type: "layout",
                fieldType: "MULTIPLEFILE",
                label: "Multiple Files",
                apiName: "",
                isRequired: false,
                value: ''
            }
        ],
        formSaved: false
    };
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);

    const record: Record = {
        sObjectTypeName: objectType,
        url: "/v1/dynamicobjecttype/"+objectType+"/fields"
    }
    const [loadingFields] = useDataProvider(record, {

    }, false, (data: any) => {
        let fields = [];
        let errorMessage = null;
        if(data.hasOwnProperty("error") && data.error !== null){
            errorMessage = data.error;
        }
        let newState = {
            fields: fields,
            errorMessage: errorMessage
        };
        if(data && Array.isArray(data?.result)){
            newState['fields'] = fields = data.result;
            fields.map(field => {
                let value = "";
                const fieldType = field.fieldType;
                newState[field.apiName] = value;
                if(fieldType === "PICKLIST"){
                    newState[field.apiName+"PicklistValues"] = field.picklistOptions;
                    newState[field.apiName+"Selection"] = [{id: value, label: value}];
                }
                return null;
            });
        }
        
        setState(newState);
    });

    const dynamicObjectTypeRecord: DynamicObjectType = {
        sObjectTypeName: objectType,
        url: "/v1/dynamicobjecttype/"+objectType
    }
    const [loadingForm] = useDataProvider(dynamicObjectTypeRecord, {

    }, false, (data: any) => {
        if(data && Array.isArray(data?.result)){
            if(data.result.length > 0){
                let dynamicObjectType = data.result[0];
                let newState = {dynamicObjectType: dynamicObjectType};
                try{
                    let layout = JSON.parse(dynamicObjectType.layout);
                    if(layout.hasOwnProperty("formType")){
                        newState['formType'] = layout.formType;
                    }
                    if(layout.hasOwnProperty("form")){
                        newState['form'] = layout.form;
                    }
                }catch(e){ }
                setState(newState);
            }
        }
    });
    function togglePanel(name){
        setState({
            expandedPanels: {
                ...state.expandedPanels,
                [name]: !state.expandedPanels[name],
            },
        });
    }
    function onFormCancel(){
        setState({
            form: [
                {
                    heading: null,
                    fields: []
                }
            ]
        });
    }
    function onFormSave(data){
        let requestData = {
            versionNumber: 1,
            status: "Published",
            schemaType: "UnifiedSchema 1.0",
            schema: {},
            salesforceObject: objectType,
            objectStorage: "DynamicObject",
            name: objectType,
            layout: {},
            apiName: objectType.toLowerCase()
        };
        if(state.dynamicObjectType !== null){
            requestData = state.dynamicObjectType;
        }
        requestData['layout'] = {
            formType: state.formType,
            form: data.form
        };
        const object: DynamicObjectType = {
            sObjectTypeName: objectType,
            url: '/v1/dynamicobjecttype',
            method: 'POST',
            headers: {},
            data: requestData
        };
        if(state.dynamicObjectType !== null){
            object.url = '/v1/dynamicobjecttype/'+state.dynamicObjectType.dynamicObjectTypeId;
            object.method = 'PATCH';
        }

        callApi(dataProvider, object).then((response: any) => {
            let result = response.result;
            if(Array.isArray(response.result)){
                result = response.result[0];
            }
            setState({dynamicObjectType: result, loading: false, formSaved: true});
        }).catch((err) => {
            let errorMessage = null;
            if(typeof(err) === "object" && err.hasOwnProperty("error")){
                errorMessage = err.error;
            }else if(typeof(err) === "object" && err.hasOwnProperty("message")){
                errorMessage = err.message;
            }
            setState({loading: false, errorMessage: errorMessage});
        });

        setState({loading: true});
    }
    function getFormFields(){
        const formFields = [];
        state.form.map((form) => {
            if(form.fields.length > 0){
                form.fields.map((field) => {
                    formFields.push(field.apiName);
                });
            }
        });
        return formFields;
    }
    function getFields(){
        let fields = [];
        state.fields.map((field) => {
            fields.push(field);
        });
        return fields;
    }
    function renderFields(fields){
        const formFields = getFormFields();
        return fields.map((field, key) => {
            return (
                <ListItem className={"field-drag-item "+(formFields.includes(field.apiName) ? 'field-drag-item-added' : '')} key={key} sx={{marginBottom: 1}}>
                    <ListItemAvatar>
                        <Avatar>
                            <ImageIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={field.label} />
                </ListItem>
            )
        });
    }
    function handleOpenMenu(event: any){
        event.preventDefault();
        setState({openMenu: event.currentTarget});
    }
    function handleCloseMenu(){
        setState({openMenu: false});
    }
    function onFormTypeChange(formType){
        let form = state.form;
        if(form.length === 1 && form[0].heading === null){
            form[0].heading = 'Page 1';
        }
        setState({
            formType: formType,
            openMenu: false,
            form: form
        });
    }
    function renderFormTypeMenu(){
        return (
            <Menu
                anchorEl={state.openMenu}
                anchorReference={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                open={Boolean(state.openMenu)}
                onClose={handleCloseMenu}
                sx={{ mt: 2 }}
                className="form-builder-types"
            >
                <MDTypography variant="h6" onClick={() => onFormTypeChange("form")}>Form</MDTypography>
                <MDTypography variant="h6" onClick={() => onFormTypeChange("wizard")}>Wizard</MDTypography>
            </Menu>
        )
    }
    function renderLayouts(layouts){
        return layouts.map((layout, key) => {
            return (
                <ListItem className="field-drag-item" key={key} sx={{marginBottom: 1}}>
                    <ListItemAvatar>
                        <Avatar>
                            <ImageIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={layout.label} />
                </ListItem>
            )
        });
    }
    const fields = getFields();
    return (
        <Grid container justifyContent="center" alignItems="flex-start">
            <Grid item xs={12} md={3} lg={3} ml="auto" mr="auto" position="relative">
                <MDBox mb={1}>
                    <MDTypography variant="p" sx={{textTransform: "capitalize"}}>
                        Display as&nbsp;
                        <Link href="/" onClick={(event) => handleOpenMenu(event)} style={{display: "inline-flex", alignItems: "center"}}>
                            {state.formType} <ArrowDropDownIcon fontSize="medium" />
                        </Link>
                    </MDTypography>
                    {renderFormTypeMenu()}
                </MDBox>
                <Accordion
                    id={"accordion-fields"}
                    expanded={((!!state.expandedPanels["panelfields"]))}
                    onChange={() => togglePanel("panelfields")}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        id={"panel-panelfields"}
                    >
                        <Typography>
                            Fields
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <List sx={{ maxHeight: 400, overflow: "auto" }}>
                            <ReactSortable
                                group={{
                                    name: 'shared',
                                    pull: 'clone',
                                    put: false
                                }}
                                animation={150}
                                list={fields}
                                sort={false}
                                setList={(data) => {
                                    // console.log('setList', data);
                                }}
                            >
                                {renderFields(fields)}
                            </ReactSortable>
                        </List>
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    id={"accordion-fields"}
                    expanded={((!!state.expandedPanels["layout"]))}
                    onChange={() => togglePanel("layout")}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        id={"panel-layout"}
                    >
                        <Typography>
                            Layout
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <List sx={{ maxHeight: 400, overflow: "auto" }}>
                            <ReactSortable
                                group={{
                                    name: 'shared',
                                    pull: 'clone',
                                    put: false
                                }}
                                animation={150}
                                list={state.layouts}
                                sort={false}
                                setList={(data) => {
                                    // console.log('setList', data);
                                }}
                            >
                                {renderLayouts(state.layouts)}
                            </ReactSortable>
                        </List>
                    </AccordionDetails>
                </Accordion>
            </Grid>
            {
                loadingForm || loadingFields ?
                    <Grid item xs={12} md={9} lg={9} ml="2" mr="auto" position="relative">
                        <Loader p={2} pt={3} color="info" />
                    </Grid>
                :
                <Grid item xs={12} md={9} lg={9} ml="2" mr="auto" position="relative">
                    <MDBox ml={2} style={{textAlign: "left"}}
                        sx={({ breakpoints }) => ({
                            [breakpoints.down("md")]: {
                                marginLeft: "0px",
                                marginTop: '16px'
                            }
                        })}
                    >
                        <FormWizard
                            formBuilder
                            formType={state.formType}
                            currentFormTab={state.currentFormTab}
                            form={state.form}
                            data={state}
                            onFormChange={(form) => setState({form: form})}
                            onFormCancel={onFormCancel}
                            onFormSave={(data) => onFormSave(data)}
                            saving={state.loading}
                        />
                    </MDBox>
                </Grid>
            }
            {
                state.formSaved ?
                    <Snackbar
                        open={state.formSaved}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        autoHideDuration={2000}
                        onClose={() => setState({formSaved: false})}
                        message="Your changes have been saved."
                    />
                :
                    null
            }
        </Grid>
    )
};

export default SetupFormWizard;